import { render, staticRenderFns } from "./Typer.vue?vue&type=template&id=2c7f24ab"
import script from "./Typer.vue?vue&type=script&lang=js"
export * from "./Typer.vue?vue&type=script&lang=js"
import style0 from "./Typer.vue?vue&type=style&index=0&id=2c7f24ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports